export enum OnHoldReasonType {
  Project = 1,
  Orderline = 2,
  Task = 3,
}
